import { ChoiceCard } from "./ChoiceCard";

export interface Choice {
  id: string;
  letter: "A" | "B" | "C" | "D";
  text: string;
}

interface ChoiceListProps {
  choices: Choice[];
  selectedId: string | null;
  onSelect: (id: string) => void;
}

export function ChoiceList({ choices, selectedId, onSelect }: ChoiceListProps) {
  return (
    <div className="flex flex-col gap-2">
      {choices.map((c) => (
        <ChoiceCard
          key={c.id}
          letter={c.letter}
          text={c.text}
          selected={selectedId === c.id}
          onSelect={() => onSelect(c.id)}
        />
      ))}
    </div>
  );
}